import { combineReducers } from 'redux'

import getDashboard from './getDashboard'

export default combineReducers({
  getDashboard: getDashboard
})
